//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import CheckIcon from '@/components/Icons/CheckIcon.vue';
import XIcon from '@/components/Icons/XIcon.vue';

export default {
  components: { CheckIcon, XIcon },
  data() {
    return {
      data: [],
      hasBusinessPlan: false,
    };
  },
  async fetch() {
    try {
      const res = await axios.get(
        'https://api.animaapp.com/get_detailed_payment_plans'
      );
      this.data = this.groupBy(res.data.body, 0);
    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    groupBy(arr, criteria) {
      return arr.reduce(function (acc, currentValue) {
        if (!acc[currentValue[criteria]]) {
          acc[currentValue[criteria]] = [];
        }
        acc[currentValue[criteria]].push(currentValue);
        return acc;
      }, {});
    },
    onPricingFeaturesVisible(isVisible) {
      if (isVisible) {
        this.$tracking.trackEvent('website.pricing-table.visible');
      }
    },
  },
};
